<template>
  <!-- Start Main Banner -->
  <div class="main-banner">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="row h-100 justify-content-center align-items-center">
            <div class="col-lg-5">
              <div class="hero-content">
                <h1>IT+ Code Lab</h1>
                <h3>Avec nos cours et nos formations, l'informatique n'a jamais eté aussi accessible</h3>
                <p>
                  Prenez part à de nombreuse formations pratiques en
                  programmation et en réseaux informatiques. Peu importe votre
                  niveau, que vous soyez debutant ou aguérit, les parcours et
                  les modules d'apprentissages que nous vous proposons
                  combleront toutes vos attentes. Que vous soyez étudiants ou
                  professionels, avec IT+ l'informatique n'aura jamais eté aussi
                  accessible.
                </p>
                <div class="d-flex">
                  <a class="read-more-btn syllabus" target="_blank" href="/SYLLABUS.pdf" download="/SYLLABUS.pdf">Télecharger le syllabus
                  </a>
                </div>
              </div>
            </div>

            <div class="col-lg-6 offset-lg-1">
              <div class="banner-image">
                <img src="../../assets/img/banner-image/man.png" class="wow fadeInDown" alt="man" />
                <img src="../../assets/img/banner-image/code.png" class="wow fadeInUp" alt="code" />
                <img src="../../assets/img/banner-image/carpet.png" class="wow fadeInLeft" alt="carpet" />
                <img src="../../assets/img/banner-image/bin.png" class="wow zoomIn" alt="bin" />
                <img src="../../assets/img/banner-image/book.png" class="wow bounceIn" alt="book" />
                <img src="../../assets/img/banner-image/dekstop.png" class="wow fadeInDown" alt="dekstop" />
                <img src="../../assets/img/banner-image/dot.png" class="wow zoomIn" alt="dot" />
                <img src="../../assets/img/banner-image/flower-top-big.png" class="wow fadeInUp" alt="flower-top-big" />
                <img src="../../assets/img/banner-image/flower-top.png" class="wow rotateIn" alt="flower-top" />
                <img src="../../assets/img/banner-image/keyboard.png" class="wow fadeInUp" alt="keyboard" />
                <img src="../../assets/img/banner-image/pen.png" class="wow zoomIn" alt="pen" />
                <img src="../../assets/img/banner-image/table.png" class="wow zoomIn" alt="table" />
                <img src="../../assets/img/banner-image/tea-cup.png" class="wow fadeInLeft" alt="tea-cup" />
                <img src="../../assets/img/banner-image/headphone.png" class="wow rollIn" alt="headphone" />

                <img src="../../assets/img/banner-image/main-pic.png" class="wow fadeInUp" alt="main-pic" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="shape1">
      <img src="../../assets/img/shape1.png" alt="IT+ formation cours informatique djibouti" />
    </div>
    <div class="shape2 rotateme">
      <img src="../../assets/img/shape2.svg" alt="IT+ formation cours informatique djibouti" />
    </div>
    <div class="shape3">
      <img src="../../assets/img/shape3.svg" alt="IT+ formation cours informatique djibouti" />
    </div>
    <div class="shape4">
      <img src="../../assets/img/shape4.svg" alt="IT+ formation cours informatique djibouti" />
    </div>
    <div class="shape5">
      <img src="../../assets/img/shape5.png" alt="IT+ formation cours informatique djibouti" />
    </div>
    <div class="shape6 rotateme">
      <img src="../../assets/img/shape4.svg" alt="IT+ formation cours informatique djibouti" />
    </div>
    <div class="shape7">
      <img src="../../assets/img/shape4.svg" alt="IT+ formation cours informatique djibouti" />
    </div>
    <div class="shape8 rotateme">
      <img src="../../assets/img/shape2.svg" alt="IT+ formation cours informatique djibouti" />
    </div>
  </div>
  <!-- End Main Banner -->
</template>

<style>
.syllabus {
  cursor: pointer;
  padding: 10px;
  border-radius: 10px;
  border: solid 1px;

}
</style>
